import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { PayablesAgingPage } from '../../features/purchasing/aging-page'
import { payablesAgingSearchSchema } from '../../features/purchasing/search'

export const Route = createFileRoute('/_app/payables-aging')({
  staticData: { crumb: 'payablesAging' },
  validateSearch: payablesAgingSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: PayablesAgingPage,
})
